import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/vercel/path0/node_modules/gatsby-theme-docz/src/base/Layout.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h2 {...{
      "id": "change-log-version-550"
    }}>{`Change Log Version: 5.5.0`}</h2>
    <h4 {...{
      "id": "20-september-2023"
    }}>{`20 September 2023`}</h4>
    <pre><code parentName="pre" {...{}}>{`- Order details page issue fixed in small devices [Issue Fix]
- Sorting and filtering issue fixed [Issue Fix]
- Internal bug fixes for both Shop and Admin [Bug Fix]
`}</code></pre>
    <h2 {...{
      "id": "change-log-version-540"
    }}>{`Change Log Version: 5.4.0`}</h2>
    <h4 {...{
      "id": "4-september-2023"
    }}>{`4 September 2023`}</h4>
    <pre><code parentName="pre" {...{}}>{`- Added wallet details to customer profile. [Enhancement]
- Added proper Order Payment summary in the shop. [Enhancement]
- Order Wallet payment issue fixed. [Issue Fix]
- Order Partial Payment (Wallet and Payment Gateway) issue fixed. [Issue Fix]
- Site title and site Subtitle  issue fixed [Issue Fix]
`}</code></pre>
    <h2 {...{
      "id": "change-log-version-530"
    }}>{`Change Log Version: 5.3.0`}</h2>
    <h4 {...{
      "id": "25-august-2023"
    }}>{`25 August 2023`}</h4>
    <pre><code parentName="pre" {...{}}>{`- Product Review Issue Fixed [Issue Fix]
- Sorting Issue Fixed [Issue Fix]
- Admin Dashboard Order Page fixed in Small Devices [Issue Fix]
- Admin Dashboard Bug Fixed [Bug Fix]
`}</code></pre>
    <h2 {...{
      "id": "change-log-version-520"
    }}>{`Change Log Version: 5.2.0`}</h2>
    <h4 {...{
      "id": "18-august-2023"
    }}>{`18 August 2023`}</h4>
    <pre><code parentName="pre" {...{}}>{`- Vendor Gross Sales & Current Balance issue fixed [Issue Fix]
- User Registration Mail confirmation issue fixed [Bug Fix]
`}</code></pre>
    <h2 {...{
      "id": "change-log-version-510"
    }}>{`Change Log Version: 5.1.0`}</h2>
    <h4 {...{
      "id": "10-august-2023"
    }}>{`10 August 2023`}</h4>
    <pre><code parentName="pre" {...{}}>{`- External Product Support Added [New Feature]
- Import Export issue fixed [Issue Fix]
- Explore slider bug fixed [Bug Fix]
`}</code></pre>
    <h2 {...{
      "id": "change-log-version-500"
    }}>{`Change Log Version: 5.0.0`}</h2>
    <h4 {...{
      "id": "26-july-2023"
    }}>{`26 July 2023`}</h4>
    <pre><code parentName="pre" {...{}}>{`- Multiple payment gateway management [new feature]
- Product publish management control [new feature]
- OpenAI integration added[New Feature]
- Added Setting Seeder [New Feature]
- New Console Command marvel:settings_seed [New Feature]
- Added Settings Dummy data seeder command [New Feature]
- Added Country wise currency formation support [New Feature]
- Admin File validation [Issue Fix]
- product out-of-stock quantity [issue fix]
- Fixed Settings issue [Issue Fix].
- product sale price [issue fix]
- multi-language auto-translation [issue fix]
`}</code></pre>
    <h2 {...{
      "id": "change-log-version-440"
    }}>{`Change Log Version: 4.4.0`}</h2>
    <h4 {...{
      "id": "2-june-2023"
    }}>{`2 June 2023`}</h4>
    <pre><code parentName="pre" {...{}}>{`- Added Coinbase (Cryptocurrency) Payment gateway
- Documentation Updated
- minor bug fix
`}</code></pre>
    <h2 {...{
      "id": "change-log-version-430"
    }}>{`Change Log Version: 4.3.0`}</h2>
    <h4 {...{
      "id": "26-may-2023"
    }}>{`26 May 2023`}</h4>
    <pre><code parentName="pre" {...{}}>{`- BitPay (Cryptocurrency) Payment Gateway
- Documentation Updated
`}</code></pre>
    <h2 {...{
      "id": "change-log-version-421"
    }}>{`Change Log Version: 4.2.1`}</h2>
    <h4 {...{
      "id": "12-may-2023"
    }}>{`12 May 2023`}</h4>
    <pre><code parentName="pre" {...{}}>{`- Fixed  Import Export issue.
`}</code></pre>
    <h2 {...{
      "id": "change-log-version-420"
    }}>{`Change Log Version: 4.2.0`}</h2>
    <h4 {...{
      "id": "18-april-2023"
    }}>{`18 April 2023`}</h4>
    <pre><code parentName="pre" {...{}}>{`- Deployment script updated.
`}</code></pre>
    <h2 {...{
      "id": "change-log-version-410"
    }}>{`Change Log Version: 4.1.0`}</h2>
    <h4 {...{
      "id": "22-march-2023"
    }}>{`22 March 2023`}</h4>
    <pre><code parentName="pre" {...{}}>{`- Added Paystack Payment Gateway
`}</code></pre>
    <h2 {...{
      "id": "change-log-version-400"
    }}>{`Change Log Version: 4.0.0`}</h2>
    <h4 {...{
      "id": "15-march-2023"
    }}>{`15 March 2023`}</h4>
    <pre><code parentName="pre" {...{}}>{`- Upgraded API to Laravel 10 & updated all other packages
- Upgraded Shop to Next JS 13 & updated all other packages
- Removed Paystack Payment Gateway due to laravel 10 depandency
`}</code></pre>
    <h2 {...{
      "id": "change-log-version-321"
    }}>{`Change Log Version: 3.2.1`}</h2>
    <h4 {...{
      "id": "28-february-2023"
    }}>{`28 February 2023`}</h4>
    <pre><code parentName="pre" {...{}}>{`- Deployment package issue fix
`}</code></pre>
    <h2 {...{
      "id": "change-log-version-320"
    }}>{`Change Log Version: 3.2.0`}</h2>
    <h4 {...{
      "id": "17-february-2023"
    }}>{`17 February 2023`}</h4>
    <pre><code parentName="pre" {...{}}>{`- Added PayStack Payment Gateway
- Added Pixer Documentation on API Welcome page
- Fixed image & thumbnail display issues
- Fixed dark mode  Payment Gateway Logo issue
- Fixed wishlist Responsive UI issue
- Remove unused code from API Welcome Page
`}</code></pre>
    <h2 {...{
      "id": "change-log-version-312"
    }}>{`Change Log Version: 3.1.2`}</h2>
    <h4 {...{
      "id": "6-february-2023"
    }}>{`6 February 2023`}</h4>
    <pre><code parentName="pre" {...{}}>{`- Fixed auto deployment script issue
`}</code></pre>
    <h2 {...{
      "id": "change-log-version-311"
    }}>{`Change Log Version: 3.1.1`}</h2>
    <h4 {...{
      "id": "1-february-2023"
    }}>{`1 February 2023`}</h4>
    <pre><code parentName="pre" {...{}}>{`- Fixed auto deployment script missing issue
`}</code></pre>
    <h2 {...{
      "id": "change-log-version-310"
    }}>{`Change Log Version: 3.1.0`}</h2>
    <h4 {...{
      "id": "17-january-2023"
    }}>{`17 January 2023`}</h4>
    <pre><code parentName="pre" {...{}}>{`- Added RazorPay Payment Gateway & Mollie Payment Gateway
- Fixed  top author not found Issue
- Fixed dark mode  progress status text color issue
- Fixed  Explore page free items sorting issue
- RazorPay  & Mollie Payment Gateway documentation
`}</code></pre>
    <h2 {...{
      "id": "change-log-version-300"
    }}>{`Change Log Version: 3.0.0`}</h2>
    <h4 {...{
      "id": "05-january-2023"
    }}>{`05 January 2023`}</h4>
    <blockquote>
      <p parentName="blockquote">{`Caution! Breaking Changes!`}</p>
    </blockquote>
    <pre><code parentName="pre" {...{}}>{`- Upgrade API to laravel 9
- Restructure the entire payment gateway system
- Added Stripe (Intent Based) and PayPal payment gateway
- Added card management feature
- Removed omnipay packages
- Added support for status-based inventory management option
- Added balance dispatch option based on status
- Fixed docker zip extension issue
- Fixed excel package cache issue
- Fixed user block and vendor inactive issue
- Fixed blank order created issue
- Fixed single-order issue
- Fixed maximum question limit issue
`}</code></pre>
    <h2 {...{
      "id": "change-log-version-230"
    }}>{`Change Log Version: 2.3.0`}</h2>
    <h4 {...{
      "id": "22-november-2022"
    }}>{`22 November 2022`}</h4>
    <pre><code parentName="pre" {...{}}>{`- Added automated script for deployment
- Documentation updated
`}</code></pre>
    <h2 {...{
      "id": "change-log-version-220"
    }}>{`Change Log Version: 2.2.0`}</h2>
    <h4 {...{
      "id": "27-october-2022"
    }}>{`27 October 2022`}</h4>
    <pre><code parentName="pre" {...{}}>{`- Added product slug edit feature
- Fixed profile update issue
- Fixed wallet points order issue
- Fixed order fail issue
- Fixed user block and vendor inactive issue
- Fixed blank order created issue
- Fixed repeated new user wallet add issue for OTP login
- Fixed negative subtotal for coupon
`}</code></pre>
    <h2 {...{
      "id": "change-log-version-210"
    }}>{`Change Log Version: 2.1.0`}</h2>
    <h4 {...{
      "id": "27-september-2022"
    }}>{`27 September 2022`}</h4>
    <pre><code parentName="pre" {...{}}>{`- Added language-based carting
- Fixed composer v2 package installation issue
- Fixed the latest docker Invalid template issue
- Fixed vendor shop page URL issue
- Fixed product status overlapping issue
- Fixed product export button URL issue
- Fixed contact us responsive issue
- Fixed privacy and help menu issue
- Fixed RTL global search position issue
- Fixed RTL question search issue
- Fixed wishlist issue
- Fixed dashboard recent withdrawal issue
- Fixed admin profile image update issue
`}</code></pre>
    <h2 {...{
      "id": "change-log-version-200"
    }}>{`Change Log Version: 2.0.0`}</h2>
    <h4 {...{
      "id": "14-august-2022"
    }}>{`14 August 2022`}</h4>
    <blockquote>
      <p parentName="blockquote">{`Caution! Breaking Changes!`}</p>
    </blockquote>
    <pre><code parentName="pre" {...{}}>{`- Introduced Multilingual feature
- Added RTL design
- Added logo upload option
- Added promotional slider image upload option
- Fixed dashboard recent withdrawal issue
- Fixed vendor item edit path issue
- Fixed translation text issue
- Fixed add new address issue at backend booking
- Fixed invoice issue for Unicode language
- Fixed Unicode product slug issue
- Fixed file upload security issue
- Fixed backend order address responsive issue
- Fixed few minor bugs
`}</code></pre>
    <h2 {...{
      "id": "change-log-version-111"
    }}>{`Change Log Version: 1.1.1`}</h2>
    <h4 {...{
      "id": "24-may-2022"
    }}>{`24 May 2022`}</h4>
    <pre><code parentName="pre" {...{}}>{`- Fixed product popup responsive issues.
`}</code></pre>
    <h2 {...{
      "id": "change-log-version-110"
    }}>{`Change Log Version: 1.1.0`}</h2>
    <h4 {...{
      "id": "23-may-2022"
    }}>{`23 May 2022`}</h4>
    <pre><code parentName="pre" {...{}}>{`- Introduced Review support for products
- Introduced Question and Answer support for products
- Introduced Report abusive review
- Introduced Review Feedback
- Introduced Q&A Feedback
- Introduced Wishlist support
- Introduced follow-following for authors
- Introduced order export support
- Introduced my question page
- Introduced my report page
- Introduced my wishlist page
- Introduced feed page
- Introduced followed authors page
- Fixed withdraw form balance issue
- Fixed category create issue
- Fixed export-import issue
- Fixed zip upload placeholder issue
- Fixed single product image issue
- Fixed free item query issue
- Fixed file download link issue
`}</code></pre>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      